export const ACTIONS = {
  DELETE: 'DELETE',
  VIEW: 'VIEW',
  UPLOAD: 'UPLOAD',
  CANCEL: 'CANCEL',
  EDIT: 'EDIT',
  SUBMIT: 'SUBMIT',
  EXTEND: 'EXTEND',
  SETUP: 'SETUP',
  ADD: 'ADD',
  DECLINE: 'DECLINE',
  MANAGE: 'MANAGE',
  DOWNLOAD: 'DOWNLOAD',
  ACCEPT: 'ACCEPT'
}

export const SUBJECTS = {
  CONTRACT: 'CONTRACT',
  DOCUMENTS: 'DOCUMENTS',
  RESPONSIBLE_USER: 'RESPONSIBLE_USER',
  TIMELINES: 'TIMELINES',
  CONTRACT_SIGNED: 'CONTRACT_SIGNED',
  HEALTH_SYSTEM: 'HEALTH_SYSTEM',
  LOP: 'LOP',
  REBATE_CONDITIONS: 'REBATE_CONDITIONS',
  ITEM_LIST: 'ITEM_LIST',
  ALL_INFO: 'ALL_INFO',
  FACILITY_USERS: 'FACILITY_USERS',
  VENDOR_CONTRACT_STEWARD: 'VENDOR_CONTRACT_STEWARD',
  INITIAL_DOCUMENT: 'INITIAL_DOCUMENT',
  NEW_DOCUMENT: 'NEW_DOCUMENT',
  NEW_DOCUMENT_VERSION: 'NEW_DOCUMENT_VERSION',
  ATTACHMENTS: 'ATTACHMENTS',
  SIGNATORY: 'SIGNATORY',
  REDLINING_BANNERS: 'REDLINING_BANNERS',
  TEMPLATES: 'TEMPLATES',
  LOP_SIGNATORY: 'LOP_SIGNATORY',
  NOTE: 'NOTE',
  MARKET_SHARE_TIERS: 'MARKET_SHARE_TIERS'
}
